import { render, staticRenderFns } from "./electiveScoreEdit.vue?vue&type=template&id=57dc3f45&scoped=true"
import script from "./electiveScoreEdit.vue?vue&type=script&lang=js"
export * from "./electiveScoreEdit.vue?vue&type=script&lang=js"
import style0 from "./electiveScoreEdit.vue?vue&type=style&index=0&id=57dc3f45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dc3f45",
  null
  
)

export default component.exports